// TODO fix this, how to avoid hard-code and get from tailwind config instead
export const LG_SCREEN_BREAK_POINT = 992;

export const gtmCommonProps = {
  customEvent: "custom-event",
  eventCategory: "zbclub",
  eventAction: "click",
};
